import React, { useCallback } from 'react';
import { LayoutWithHeader } from '@components/layout/LayoutWithHeader';
import routes from '@config/routes';
import { CmsContentRenderer } from '@features/cms/components/cms-content-renderer';
import { Container } from '@goodfynd/layout';
import { Button, FlexView } from '@goodfynd/ui';
import { getDashboardRoutePath } from '@utils/routes-util';
import Head from 'next/head';

import { setPageTitle } from '../utils/base';

export default function Custom500() {
  const reload = useCallback(() => {
    window.location.reload();
  }, []);

  return (
    <LayoutWithHeader>
      <Head>
        <title>{setPageTitle('Oops, something went wrong 😭')}</title>
        <meta content="noindex, nofollow" name="robots" />
      </Head>

      <Container
        css={{
          '&.MuiContainer-root': {
            alignItems: 'center',
            display: 'flex',
            flexDirection: 'column',
            gap: 8,
            padding: 32,
          },
        }}
      >
        <CmsContentRenderer slug="vendor-500" />

        <FlexView>
          <Button onClick={reload} rank="secondary">
            Reload
          </Button>
          <Button href={getDashboardRoutePath(routes.dashboard.overview, '~')}>
            Back to Dashboard
          </Button>
        </FlexView>
      </Container>
    </LayoutWithHeader>
  );
}
